<h1 class="text-center !text-3xl !font-normal text-tertiary-900">
    What would you like to do?
</h1>
<h2 class="text-center !text-base !font-medium text-tertiary-900">
    Cevo Go is for VHF and UHF. <br />For 800/900 MHz and other bands, please
    use
    <a
        class="text-primary-700 hover:text-primary-800"
        [routerLink]="[getDashboardRoute()]"
        >Cevo</a
    >.
</h2>

<form [formGroup]="form" class="flex flex-col space-y-4">
    <mat-radio-group class="flex flex-col space-y-4">
        <mat-expansion-panel
            #newLicenseExpansionPanel
            [expanded]="false"
            [hideToggle]="true"
            [disabled]="true"
            (opened)="
                onApplicationPurposeChange(
                    goApplicationPurposeCodeEnum.NewLicense
                )
            "
            [ngClass]="{
                'invalid-panel':
                    shouldHighlightApplicationPurposeExpansionPanel(),
            }"
            (click)="onExpansionPanelClick(newLicenseRadioButton)"
        >
            <mat-expansion-panel-header [ngStyle]="{ cursor: 'default' }">
                <mat-panel-description>
                    <div class="flex flex-col">
                        <mat-radio-button
                            #newLicenseRadioButton
                            color="primary"
                            [value]="goApplicationPurposeCodeEnum.NewLicense"
                            (change)="onRadioButtonChange($event)"
                        >
                            <span class="text-lg text-tertiary-900"
                                >Apply for a New License</span
                            >
                        </mat-radio-button>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="ml-12">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label
                        >Optional - FCC registration number (FRN)</mat-label
                    >
                    <input
                        title="FCC registration number (FRN)"
                        matInput
                        formControlName="fccRegistrationNumber"
                        [appRegexInput]="regExPattern.NumericOnly"
                        [maxLength]="
                            htmlInputConstants.FCC_REGISTRATION_NUMBER_MAX_LENGTH
                        "
                    />
                </mat-form-field>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel
            #newLocationExpansionPanel
            [expanded]="false"
            [hideToggle]="true"
            [disabled]="true"
            (opened)="
                onApplicationPurposeChange(
                    goApplicationPurposeCodeEnum.NewLocation
                )
            "
            [ngClass]="{
                'invalid-panel':
                    shouldHighlightApplicationPurposeExpansionPanel(),
            }"
            (click)="onExpansionPanelClick(newLocationRadioButton)"
        >
            <mat-expansion-panel-header [ngStyle]="{ cursor: 'default' }">
                <mat-panel-description>
                    <div class="flex flex-col">
                        <mat-radio-button
                            #newLocationRadioButton
                            color="primary"
                            [value]="goApplicationPurposeCodeEnum.NewLocation"
                            (change)="onRadioButtonChange($event)"
                        >
                            <span class="text-lg text-tertiary-900"
                                >Add a New Location</span
                            >
                        </mat-radio-button>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="ml-12">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Call Sign</mat-label>
                    <input
                        title="Call sign"
                        [formControl]="form.controls.callSign"
                        matInput
                        [appRegexInput]="regExPattern.Alphanumeric"
                        [imask]="imask.uppercase"
                        [maxLength]="htmlInputConstants.CALL_SIGN_MAX_LENGTH"
                    />
                    @if (getCallSignError(); as error) {
                        <mat-error>{{ error }}</mat-error>
                    }
                </mat-form-field>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel
            #newFrequenciesExpansionPanel
            [expanded]="false"
            [hideToggle]="true"
            [disabled]="true"
            (opened)="
                onApplicationPurposeChange(
                    goApplicationPurposeCodeEnum.NewFrequencies
                )
            "
            [ngClass]="{
                'invalid-panel':
                    shouldHighlightApplicationPurposeExpansionPanel(),
            }"
            (click)="onExpansionPanelClick(newFrequenciesRadioButton)"
        >
            <mat-expansion-panel-header [ngStyle]="{ cursor: 'default' }">
                <mat-panel-description>
                    <div class="flex flex-col">
                        <mat-radio-button
                            #newFrequenciesRadioButton
                            color="primary"
                            [value]="
                                goApplicationPurposeCodeEnum.NewFrequencies
                            "
                            (change)="onRadioButtonChange($event)"
                        >
                            <span class="text-lg text-tertiary-900"
                                >Add Frequencies</span
                            >
                        </mat-radio-button>
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="ml-12">
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Call Sign</mat-label>
                    <input
                        title="Call sign"
                        [formControl]="form.controls.callSign"
                        matInput
                        [appRegexInput]="regExPattern.Alphanumeric"
                        [imask]="imask.uppercase"
                        [maxLength]="htmlInputConstants.CALL_SIGN_MAX_LENGTH"
                    />
                    @if (getCallSignError(); as error) {
                        <mat-error>{{ error }}</mat-error>
                    }
                </mat-form-field>
            </div>
        </mat-expansion-panel>
    </mat-radio-group>
</form>
